module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Storage Ottoman_Caramel.70f12473.png";